import { Box } from '@mui/material';
import { memo, useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

import Typography from '../../../../../../../../common/typography';
import { formatToAmount } from '../../../../../../../../../constants/helpers/utils';
import { ClientBalanceContext, ClientBalanceAmount, balanceAmountColorMapper } from '../../../../../../client-balance';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));

const BalanceInfo = () => {
  const classes = useStyles();
  const { getClientBalance } = useContext(ClientBalanceContext);

  const balance = getClientBalance('balance') as ClientBalanceAmount;

  return (
    <Box className={classes.container}>
      <Box mb={0.5}>
        <Typography size={14} color="white">
          Balance
        </Typography>
      </Box>
      <Typography
        size={balance && balance <= 999999999 ? 22 : 16}
        color={balanceAmountColorMapper({ balance, isMobile: true })}
      >
        {formatToAmount(balance)}
      </Typography>
    </Box>
  );
};

export default memo(BalanceInfo);
